import axios from "../../../api/axios";
import { toast } from "react-toastify";
import { INVOICE_ENDPOINTS } from "./Api";

// The invoice document is rendered server-side by Chrome (see
// invoice.pdf.service.ts), so print and download share one template and the PDF
// keeps real vector text.

const documentUrl = (invoice, format) => {
  const id = invoice && (invoice._id || invoice.id);
  if (!id) return null;
  const base = INVOICE_ENDPOINTS.INVOICE_DOCUMENT.replace(":id", id);
  return format ? `${base}?format=${format}` : base;
};

const fileNameFor = (invoice) =>
  invoice && invoice.invoiceNo != null && invoice.invoiceNo !== ""
    ? `Invoice-RD-${invoice.invoiceNo}.pdf`
    : "Invoice.pdf";

// Kept for API compatibility with the previous client-side renderer; the heavy
// pdf libraries it used to warm up are no longer bundled.
export const prefetchPdfLibs = () => {};

export const downloadInvoicePdf = async (invoice) => {
  const url = documentUrl(invoice);
  if (!url) return;
  try {
    const res = await axios.get(url, { responseType: "blob" });
    const blob = new Blob([res.data], { type: "application/pdf" });
    const href = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = href;
    link.download = fileNameFor(invoice);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(href);
  } catch (e) {
    console.error("invoice pdf download failed", e);
    toast.error("Could not generate the PDF — please try again");
  }
};

export const printInvoice = async (invoice) => {
  const url = documentUrl(invoice, "html");
  if (!url) return;

  const popup = window.open("", "_blank", "width=920,height=1100");
  if (!popup) {
    toast.error("Allow pop-ups for this site to print the invoice");
    return;
  }

  try {
    const res = await axios.get(url);
    popup.document.open();
    popup.document.write(res.data);
    popup.document.close();
    popup.focus();
    // Give the webfonts a moment so the printed sheet matches the PDF.
    popup.setTimeout(() => popup.print(), 600);
  } catch (e) {
    console.error("invoice print failed", e);
    popup.close();
    toast.error("Could not open the invoice for printing");
  }
};
